export enum VehicleCondition_Enum {
  New,
  Used
}
